import classes from "./Register.module.css"
import { useTranslation } from "react-i18next"
import { Row, Col, Button, Input, Checkbox, Form, DatePicker, Select, Modal } from 'antd'
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import HelmetComponent from '../../components/Helmet/Helmet'
import type { DatePickerProps } from 'antd';
import locale from 'antd/es/date-picker/locale/el_GR';
import dayjs from 'dayjs';
import 'dayjs/locale/el';
import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";



const Login = () => {
    const { t } = useTranslation()
    const navigate = useNavigate();
    dayjs.locale('el');
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [sharing, setSharing] = useState<1 | 0>(0);
    const [dateOfBirth, setDateOfBirth] = useState<string>("")
    const [showModalTerms, setShowModalTerms] = useState(false);
    const [form] = Form.useForm();


    const onChangeSharing = (e: CheckboxChangeEvent) => {
        const checked = e.target.checked;
        setSharing(checked ? 1 : 0);
    };

    const onFinish = async (values: any) => {
        const formattedDateOfBirth = dayjs(dateOfBirth).format('DD-MM-YYYY');
        console.log(formattedDateOfBirth);
        try {
            const url = `https://admin-vrraces.pavlosmelas.gr/api/register`;

            const data = {
                name: values.name.toString(),
                surname: values.surname.toString(),
                email: values.email.toString(),
                password: values.pass.toString(),
                // confirm_password: values.confirm_pass.toString(),
                gender: values.gender.toString(),
                date_of_birth: formattedDateOfBirth.toString(),
                place_of_birth: values.place_of_birth.toString(),
                residence: values.residence.toString(),
                club: values.club.toString(),
                itra: values.itra.toString(),
                // approves_result_sharing: sharing,
                name_is_public: 1,
                surname_is_public: 1,
                club_is_public: 1,
                itra_is_public: 1,
                gender_is_public: 1,
                email_is_public: 1,
                place_of_birth_is_public: 1,
                date_of_birth_is_public: 1,
                residence_is_public: 1
            };

            const headers = {
                Accept: 'application/json'
            };

            const response = await axios.post(url, data, { headers });
            console.log('Response:', response.data);
            navigate('/login')
        } catch (error) {
            console.log(error);

            if (axios.isAxiosError(error)) {
                if (error.response) {
                    setErrorMessage(error.response.data.message);
                } else {
                    setErrorMessage(error.message);
                }
            }
        }
    };

    const onChange: DatePickerProps['onChange'] = (date, dateString) => {
        // dateString.format('YYYY-MM-DD HH:mm:ss');
        // console.log(date, dateString);
        console.log(dateString);

        setDateOfBirth(dateString);

    };

    const handleGender = (value: string) => {
        console.log(`selected ${value}`);
    };

    return (
        <>
            <HelmetComponent title='Search' descrition='Αναζήτηση' />

            <Modal
                className={classes.confirmModal}
                open={showModalTerms}
                title=""
                onCancel={() => { setShowModalTerms(false) }}
                onOk={() => { setShowModalTerms(false) }}
                cancelButtonProps={{ style: { display: 'none' } }}
                okText="ΚΛΕΙΣΙΜΟ"
            >


                <strong>Όροι και Προϋποθέσεις Χρήσης</strong><br /><br />
                Οι παρακάτω Όροι και Προϋποθέσεις Χρήσης ισχύουν και καλύπτουν τη χρήση της εφαρμογής του Δήμου Παύλου Μελά, από κάθε χρήστη, σε κάθε μέσο μετάδοσής της (ηλεκτρονικού υπολογιστή, κινητού τηλεφώνου, tablet ή οποιασδήποτε άλλης πλατφόρμας) και σε κάθε μορφή μετάδοσης του περιεχομένου της (website, application κ.ά.).
                <br /><br />
                Η εν λόγω εφαρμογή αποτελεί ιδιοκτησία του Δήμου Παύλου Μελά που εδρεύει στην Καραολή και Δημητρίου 1, Σταυρούπολη, 56430, ΘΕΣΣΑΛΟΝΙΚΗΣ τηλ. 23133 02800, e-mail: dpo@pavlosmelas.gr.
                <br /><br />
                Η χρήση της εφαρμογής και τα σχετικά με αυτήν δικαιώματα και υποχρεώσεις διέπονται από τους όρους και προϋποθέσεις που παρατίθενται στο παρόν και στα αναπόσπαστα τμήματά του και ισχύουν για το σύνολο του περιεχομένου της και των επιμέρους σελίδων της.
                <br /><br />
                Κάθε επισκέπτης/χρήστης που επισκέπτεται, περιηγείται και χρησιμοποιεί με κάθε τρόπο την ηλεκτρονική εφαρμογή του Δήμου καθώς και των όποιων υπηρεσιών διατίθενται προς χρήση μέσω αυτής, τεκμαίρεται, αυτομάτως, ότι έχει λάβει πλήρη γνώση και συμφωνεί με το περιεχόμενο των όρων χρήσης που αναφέρονται κατωτέρω. Συνίσταται, επομένως, σε όλους τους επισκέπτες/χρήστες των διαδικτυακών τόπων και υπηρεσιών του Δήμου να μελετήσουν και να βεβαιωθούν ότι κατανοούν πλήρως τους όρους χρήσης της. Σε περίπτωση που κάποιος χρήστης/επισκέπτης δεν συμφωνεί με τους αναφερόμενους όρους χρήσης, οφείλει με δική του ευθύνη, να εξέλθει από την ηλεκτρονική εφαρμογή του Δήμου και να απόσχει εν γένει από κάθε χρήση των υπηρεσιών και του περιεχομένου της.
                <br /><br />
                Οι αναφερόμενοι οροί και προϋποθέσεις χρήσης της mobile application του Δήμου, και οι πιθανές τροποποιήσεις τους, διέπονται από το εθνικό και το κοινοτικό δίκαιο, καθώς και τις σχετικές διεθνείς συνθήκες. Σε περίπτωση αντίθεσης που προκύψει από τροποποίηση των ανωτέρω νομικών πλαισίων, οι Όροι και Προϋποθέσεις χρήσης που επηρεάζονται θα τροποποιούνται αντιστοίχως, ενώ το σύνολο του κειμένου των όρων/προϋποθέσεων θα παραμένει ως έχει.
                <br /><br />
                Ο Δήμος Παύλου Μελά διατηρεί εις ολόκληρον και σε κάθε περίπτωση το δικαίωμα μονομερούς μεταβολής των όρων χρήσης και των προϋποθέσεων αυτής, χωρίς προηγούμενη ενημέρωση των χρηστών/επισκεπτών αυτής. Ο Δήμος υποχρεούται να παρέχει ενημέρωση σχετική με κάθε αλλαγή των όρων και προϋποθέσεων χρήσης, μέσω της ηλεκτρονικής ανανέωσης της εκάστοτε ισχύουσας έκδοσης των όρων χρήσης. Οι επισκέπτες/χρήστες που συνεχίζουν να χρησιμοποιούν τις υπηρεσίες του Δήμου θεωρείται αυτομάτως ότι συμφωνούν με τους νέους όρους και προϋποθέσεις χρήσης που έχει θέσει ο Δήμος. Για το λόγο αυτό, συνίσταται στους χρήστες/επισκέπτες των υπηρεσιών και του περιεχομένου του Δήμου να επισκέπτονται, να διαβάζουν και να ελέγχουν, ανά τακτά διαστήματα, αν συμφωνούν με στις όρους χρήσης προκειμένου να προχωρούν στις αντίστοιχες ενέργειες.
                <br /><br />

                <strong>ΠΛΗΡΟΦΟΡΙΕΣ ΚΑΙ ΥΠΗΡΕΣΙΕΣ – ΠΕΡΙΟΡΙΣΜΟΣ ΕΥΘΥΝΗΣ</strong><br /><br />
                Ο Δήμος Παύλου Μελά δεσμεύεται ότι παρέχει στους χρήστες/επισκέπτες της mobile εφαρμογής της, πληροφορίες οι οποίες είναι αληθείς, ακριβείς και πλήρεις, βρίσκονται σε άμεσο συσχετισμό με την ταυτότητα, τη λειτουργία και τις υπηρεσίες της εφαρμογής. Ο Δήμος δεν ευθύνεται για την προσωρινή μη διαθεσιμότητα, δυσλειτουργία ή τεχνικά θέματα που τυχόν εμφανισθούν κατά την κοινή χρήση. Επιπλέον, όσον αφορά τις εκ σφάλματος καταχωρήσεις ηλεκτρονικών δεδομένων ο Δήμος διατηρεί το δικαίωμα να προβαίνει σε διόρθωση αυτών.
                <br /><br />
                Ο Δήμος Παύλου Μελά φέρει την ευθύνη συνεχούς ελέγχου της ποιότητας παροχής των πληροφοριών και των υπηρεσιών που προβάλλονται και παρέχονται μέσω της mobile εφαρμογής του. Σε κάθε περίπτωση, ο Δήμος δεν φέρει την αποκλειστική ευθύνη προφύλαξης των χρηστών/επισκεπτών της mobile application από κάθε είδους σφάλματα και ιούς που οφείλονται σε παρεμβάσεις τρίτων. Επιπλέον, δεν ευθύνεται αστικώς ή ποινικώς για οποιαδήποτε ζημία θετική, ειδική ή αποθετική, η οποία ενδεικτικά και όχι περιοριστικά, διαζευκτικά ή/και σωρευτικά συνίσταται σε απώλεια κερδών, δεδομένων, διαφυγόντα κέρδη, χρηματική ικανοποίηση κ.λπ., που προκύπτει είτε από τη χρήση/αντιγραφή/φόρτωση (download), την πλοήγηση σε αυτή́ & τη χρήση των υπηρεσιών ή των πληροφοριών που περιέχονται σε αυτή, είτε από γενική αλλοίωση του περιεχομένου του διαδικτυακού τόπου της ή από άλλες μη επιτρεπόμενες παρεμβάσεις τρίτων σε αρχεία και πληροφορίες που διατίθενται μέσω της εφαρμογής. Επιπροσθέτως, οι χρήστες/επισκέπτες της εφαρμογής θα πρέπει κατά την περιήγησή τους στο διαδίκτυο, ήτοι και κατά την περιήγησή τους στην εφαρμογή του Δήμου, να λαμβάνουν κάθε πρόσφορο μέτρο ασφαλείας από τυχόν κινδύνους που παρουσιάζονται κατά την κοινή χρήση του διαδικτύου (π.χ. να προστατεύουν την περιήγησή τους με πρόγραμμα προφύλαξης από ιούς).
                <br /><br />
                Η χρήση που τελούν οι επισκέπτες της εφαρμογής, θα πρέπει να ακολουθεί και να σέβεται τις προσταγές των κανόνων και των διατάξεων του Ελληνικού, Ευρωπαϊκού και Διεθνούς Δικαίου, καθώς και κάθε σχετικής με τη χρήση ιστοσελίδων/εφαρμογών νομοθεσίας. Πιο συγκεκριμένα, θα πρέπει σε κάθε να απόσχουν από κάθε παράνομη και καταχρηστική δραστηριότητα κατά τη χρήση της εφαρμογής του Δήμου Παύλου Μελά ή/και σε σχέση με αυτήν.
                <br /><br />

                <strong>ΔΙΚΑΙΩΜΑΤΑ ΠΝΕΥΜΑΤΙΚΗΣ ΙΔΙΟΚΤΗΣΙΑΣ</strong><br /><br />
                Τα στοιχεία που εμφανίζονται στην εφαρμογή, ήτοι το περιεχόμενο της παρούσης εφαρμογής (εικόνες, φωτογραφίες, κείμενα, υπηρεσίες, προγράμματα, πληροφορίες, δεδομένα κ.λπ.) καθώς και των παρεχόμενων, από αυτήν, υπηρεσιών προς τους χρήστες αποτελεί πνευματική ιδιοκτησία και ανήκει στην σφαίρα δικαιωμάτων χρήσης του Δήμου Παύλου Μελά και προστατεύονται από τους κανόνες του ελληνικού, ευρωπαϊκού και διεθνούς δικαίου περί πνευματικής και βιομηχανικής ιδιοκτησίας και αθέμιτου ανταγωνισμού, καθώς και κάθε άλλης σχετικής διάταξης, ενώ ανήκουν κατ’ αποκλειστικότητα στον Δήμο ή στον εκάστοτε πνευματικό δημιουργό τους.
                <br /><br />
                Σε κάθε περίπτωση, απαγορεύεται κάθε είδους αντιγραφή, αναπαραγωγή με οποιοδήποτε μέσο, μεταφορά, μεταποίηση, μεταπώληση, παραγωγή νέων εργασιών με βάση το περιεχόμενο της παρούσας εφαρμογής καθώς και η παραπλάνηση του κοινού σχετικά με τον πραγματικό πάροχο των παραπάνω δεδομένων και υπηρεσιών. Ο σχεδιασμός ειδικών ονομάτων, εικόνων, λογοτύπων, διακριτικών γνωρισμάτων καθώς και η χρήση κάθε άλλου είδους που αποτελεί προϊόν των στοιχείων και των υπηρεσιών που παράγονται και αξιοποιούνται για την εξυπηρέτηση και την προώθηση της λειτουργίας του Δήμου Παύλου Μελά, αποτελούν περιουσιακά στοιχεία αυτού. Η παροχή και η εμφάνιση των δεδομένων και υπηρεσιών προς τρίτους, δεν συνίσταται ούτε θα πρέπει να εκλαμβάνεται ως μεταβίβαση ή εκχώρηση άδειας ή δικαιώματος καθολικής χρήσης τους, δεδομένου ότι προστατεύονται από τις διατάξεις περί εμπορικών σημάτων. Οι παραπάνω δραστηριότητες (μεμονωμένα ή συγκεντρωτικά) μπορεί να επιτρέπονται μόνο μετά από έγγραφη συναίνεση (άδεια) του Δήμου.

                <br /><br /><br />
                <strong>Προσωπικά Δεδομένα</strong><br /><br />

                <strong>Ποια προσωπικά μου δεδομένα συλλέγονται και πώς;</strong><br /><br />

                Τα προσωπικά δεδομένα τα οποία συλλέγει και επεξεργάζεται ο Δήμος Παύλου Μελά είναι μόνο αυτά που είναι απαραίτητα για τον εκάστοτε συγκεκριμένο και σαφώς ορισμένο σκοπό και τη συγκεκριμένη νομική βάση.
                <br /><br />
                Στο πλαίσιο αυτό, η επεξεργασία που λαμβάνει χώρα αφορά τα προσωπικά δεδομένα που παρέχετε στον Δήμο Παύλου Μελά σε πραγματικό διαδραστικό χρόνο, όταν χρησιμοποιείτε τις υπηρεσίες μας, τους επίσημους διαδικτυακούς τόπους μας, για παράδειγμα κάνοντας εγγραφή, όπως:
                <br /><br />
                <ul style={{ listStyleType: 'disc', paddingLeft: '2rem' }}>
                    <li>Όνομα</li>
                    <li>Επώνυμο</li>
                    <li>E-mail</li>
                </ul>
                <br />
                Σε όσες από τις περιπτώσεις η επεξεργασία θεμελιώνεται στη λήψη συγκατάθεσης, ο Δήμος Παύλου Μελά ακολουθεί τις προβλεπόμενες από το Νόμο διαδικασίες για τη λήψη αυτής.
                <br /><br />
                <strong>Για ποιους σκοπούς γίνεται η επεξεργασία και ποια η νομική της βάση;</strong><br /><br />

                Τα προσωπικά δεδομένα συλλέγονται σύμφωνα με τον ΓΚΠΔ και την ισχύουσα νομοθεσία, είτε με την έναρξη της σχέσης σας με τον Οργανισμό είτε και μεταγενέστερα και αποτελούν αντικείμενο επεξεργασίας με νομική βάση:
                <br /><br />
                Τη συγκατάθεσή σας, όταν απαιτείται
                <br /><br />
                <ul style={{ listStyleType: 'disc', paddingLeft: '2rem' }}>
                    <li>Την εκτέλεση μιας μεταξύ μας σύμβασης</li>
                    <li>Την εκπλήρωση των νομικών μας υποχρεώσεων</li>
                    <li>Τη διαφύλαξη ζωτικού συμφέροντος</li>
                    <li>Την εκπλήρωση καθήκοντος για το δημόσιο συμφέρον</li>
                    <li>Τη διαφύλαξη έννομου συμφέροντός μας ή τρίτου</li>
                </ul>
                <br /><br />
                Ο Δήμος Παύλου Μελά μπορεί να επεξεργαστεί τα προσωπικά σας δεδομένα, για τους ακόλουθους σκοπούς ανά νομική βάση:
                <br /><br />
                <ol>
                    <li>
                        1. Με τη συγκατάθεσή σας

                        Μεταβίβαση προσωπικών δεδομένων σε τρίτους

                        Αποστολή ενημερώσεων
                    </li>
                    <br />

                    <li>
                        2. Για την εκπλήρωση της συμβατικής υποχρέωσης σε περίπτωση σύναψης σύμβασης με τον Δήμο Παύλου Μελά ή κατά την προσυμβατική διαδικασία

                        Για την επικοινωνία κατά την προσυμβατική διαδικασία ή κατά την εκτέλεση της σύμβασης
                    </li>
                    <br />

                    <li>
                        3. Για την εκπλήρωση των νομικών μας υποχρεώσεων

                        Για την εκπλήρωση των υποχρεώσεών μας σύμφωνα με την ισχύουσα νομοθεσία έναντι δημοσίων αρχών και φορέων (Εποπτικές, Ανεξάρτητες, Αστυνομικές, Δικαστικές).
                    </li>
                    <br />

                    <li>
                        4. Για τη διαφύλαξη ζωτικού συμφέροντος σας ή τρίτου

                        Σε περίπτωση που κινδυνεύει η ζωή σας ή η ζωή τρίτου
                    </li>
                    <br />

                    <li>
                        5. Για λόγους έννομου συμφέροντός μας, ως:

                        Για την ανάπτυξη και βελτίωση των παρεχόμενων υπηρεσιών μας μέσα από τις δραστηριότητες και τα ενδιαφέροντά σας.

                        Για τη διαχείριση των παραπόνων σας.

                        Για την προστασία και ασφάλεια των συστημάτων πληροφορικής.

                        Ποιοι είναι οι αποδέκτες των προσωπικών μου δεδομένων;

                        Πρόσβαση στα προσωπικά σας δεδομένα έχει το προσωπικό του Δήμου Παύλου Μελά, στα πλαίσια της εκτέλεσης των καθηκόντων που τους ανέθεσε ο Δήμος Παύλου Μελά ως υπεύθυνος επεξεργασίας.

                        Ο Δήμος Παύλου Μελά είναι υποχρεωμένος ή δικαιούται να κοινοποιεί τα προσωπικά σας δεδομένα σε διάφορους τρίτους αποδέκτες όπως:

                        Δημόσιους φορείς

                        Ανεξάρτητες αρχές

                        υπό τον όρο της τήρησης σε κάθε περίπτωση του απορρήτου και του καθήκοντος εμπιστευτικότητας και εχεμύθειας.
                    </li>
                    <br />
                </ol>

                <strong>Πόσο χρόνο διατηρούνται τα δεδομένα μου;</strong><br /><br />

                Ο Δήμος Παύλου Μελά διατηρεί τα προσωπικά σας δεδομένα μόνον για το διάστημα που απαιτείται για τους σκοπούς της επεξεργασίας. Ωστόσο οφείλει να διατηρεί τα προσωπικά δεδομένα και για χρονικό διάστημα που καθορίζεται από το ισχύον νομικό και κανονιστικό πλαίσιο.


                <br /><br />
                <strong>Τι είναι τα cookies και γιατί τα συλλέγει ο Δήμος Παύλου Μελά;</strong><br /><br />

                Για να διασφαλίσουμε ότι ο ιστότοπός μας λειτουργεί σωστά, ενδέχεται μερικές φορές να αποθηκευτεί ένα μικρό κομμάτι δεδομένων, που είναι γνωστό ως cookie, στον υπολογιστή ή την κινητή συσκευή σας κατά την επίσκεψη του ιστότοπού μας. Ένα cookie είναι ένα αρχείο κειμένου που αποθηκεύεται από έναν διακομιστή ιστού σε έναν υπολογιστή ή μια κινητή συσκευή. Το περιεχόμενο ενός cookie μπορεί να ανακτηθεί ή να διαβαστεί μόνο από τον διακομιστή που δημιουργεί το cookie. Το κείμενο σε ένα cookie αποτελείται συχνά από αναγνωριστικά, ονόματα τοποθεσιών και ορισμένους αριθμούς και χαρακτήρες. Τα cookies είναι μοναδικά για τα προγράμματα περιήγησης ή τις κινητές εφαρμογές που χρησιμοποιείτε και επιτρέπουν στους ιστότοπους να αποθηκεύουν δεδομένα όπως οι προτιμήσεις σας.
                <br /><br />

                <strong>Πώς προστατεύονται τα δεδομένα μου;</strong><br /><br />

                Στον Δήμο Παύλου Μελά εργαζόμαστε καθημερινά για να εξασφαλίσουμε ότι τα προσωπικά δεδομένα που λαμβάνουμε:
                <br /><br />
                Υποβάλλονται σε σύννομη και θεμιτή επεξεργασία με διαφανή τρόπο σε σχέση με το υποκείμενο των δεδομένων.
                <br /><br />
                Συλλέγονται αποκλειστικά για συγκεκριμένους και νόμιμους σκοπούς.
                <br /><br />
                Είναι επαρκή, σχετίζονται με τον σκοπό για τον οποίο τα συλλέγουμε και περιορίζονται στα απαραίτητα.
                <br /><br />
                Είναι ακριβή και ενημερωμένα.
                <br /><br />
                Διατηρούνται αποκλειστικά εντός του καθορισμένου χρονικού πλαισίου και όχι περισσότερο.
                <br /><br />
                Τίθενται σε επεξεργασία με τέτοιο τρόπο ώστε να εξασφαλίζεται η απαραίτητη προστασία τους.
                <br /><br />
                <strong>Ποια είναι τα δικαιώματά μου;</strong><br /><br />

                Ο Δήμος Παύλου Μελά δεν επεξεργάζεται με αυτοματοποιημένο τρόπο και δεν δημιουργεί προφίλ για κανένα φυσικό πρόσωπο του οποίου διατηρεί τα προσωπικά δεδομένα
                <br /><br />

                Το υποκείμενο των δεδομένων έχει τα ακόλουθα δικαιώματα:
                <br /><br />

                <ul style={{ listStyleType: 'disc', paddingLeft: '2rem' }}>
                    <li>Το δικαίωμα πρόσβασης</li>
                    <li>Μπορείτε ανά πάσα στιγμή να ενημερωθείτε από εμάς για τα προσωπικά σας δεδομένα που διατηρούμε, και να έχετε πρόσβαση σε αυτά.</li>
                    <li>Το δικαίωμα στη διόρθωση δεδομένων</li>
                    <li>Έχετε τη δυνατότητα να απευθυνθείτε σε εμάς για να διορθώσουμε τα δεδομένα που είναι ανακριβή ή ελλιπή.</li>
                    <li>Το «δικαίωμα στη λήθη»</li>
                    <li>Εφόσον δεν μας υποχρεώνει κάποιο νομοθετικό πλαίσιο να διατηρήσουμε τα δεδομένα που διατηρούμε και σχετίζονται με εσάς, μπορείτε να μας ζητήσετε να τα διαγράψουμε.</li>
                    <li>Το δικαίωμα στη φορητότητα των δεδομένων</li>
                    <li>Μπορείτε να μας ζητήσετε να διαβιβάσουμε τα δεδομένα σας σε άλλο δημόσιο ή ιδιωτικό φορέα.</li>
                    <li>Το δικαίωμα στην εναντίωση και στον περιορισμό της επεξεργασίας</li>
                    <li>Σε περίπτωση που διαφωνείτε με τον τρόπο που επεξεργαζόμαστε τα προσωπικά σας δεδομένα μπορείτε να αιτηθείτε τη διακοπή ή τον περιορισμό της επεξεργασίας.</li>
                    <li>Το δικαίωμα άρσης συγκατάθεσης</li>
                    <li>Έχετε το δικαίωμα να αποσύρετε τη συγκατάθεσή σας στην επεξεργασία των δεδομένων σας ανά πάσα στιγμή.</li>
                </ul>
                <br /><br />
                Ο Δήμος Παύλου Μελά θα καταβάλει κάθε προσπάθεια να απαντήσει στο αίτημα που θα υποβάλλετε χωρίς καθυστέρηση και σε κάθε περίπτωση εντός μηνός από την παραλαβή του. Η εν λόγω προθεσμία παρατείνεται για δύο (2) ακόμα μήνες, εφόσον είναι απαραίτητο λαμβάνοντας υπόψη την πολυπλοκότητα του αιτήματος και το πλήθος των αιτημάτων. Ο Δήμος Παύλου Μελά θα σας ενημερώσει για την εν λόγω παράταση εντός μηνός από την παραλαβή του αιτήματος, καθώς και για τους λόγους της καθυστέρησης. Εάν έχετε υποβάλει το αίτημα με ηλεκτρονικά μέσα, η ενημέρωση παρέχεται, εάν είναι δυνατόν, με ηλεκτρονικά μέσα, εκτός εάν εσείς ζητήσετε κάτι διαφορετικό.
                <br /><br />

                Εφόσον ο Δήμος Παύλου Μελά ικανοποιήσει αίτημά σας α) για περιορισμό επεξεργασίας των δεδομένων σας ή β) για άρνηση επεξεργασίας των δεδομένων σας ή γ) για διαγραφή των δεδομένων σας από τα αρχεία του οργανισμού και εφόσον αυτά είναι απαραίτητα για την κατάρτιση ή τη συνέχιση και εκτέλεση σύμβασης, τότε αυτό συνεπάγεται αυτοδίκαια είτε την καταγγελία από εσάς της αντίστοιχης σύμβασης ή τη μη δυνατότητα επεξεργασίας του σχετικού σας αιτήματος.
                <br /><br />

                <strong>Ανάκληση της συγκατάθεσης</strong><br /><br />

                Έχετε το δικαίωμα να ανακαλέσετε τη συγκατάθεσή σας ανά πάσα στιγμή. Η ανάκληση της συγκατάθεσης σας δε θίγει τη νομιμότητα της επεξεργασίας που βασίστηκε σε αυτή και έγινε πριν της ανάκλησής της.
                <br /><br />

                <strong>Cookies</strong><br /><br />
                Για να διασφαλίσουμε ότι ο ιστότοπός μας και η εφαρμογή για κινητές συσκευές λειτουργούν σωστά, ενδέχεται μερικές φορές να τοποθετήσουμε ένα μικρό κομμάτι δεδομένων που είναι γνωστό ως cookie στον υπολογιστή ή την κινητή συσκευή σας. Ένα cookie είναι ένα αρχείο κειμένου που αποθηκεύεται από έναν διακομιστή ιστού σε έναν υπολογιστή ή μια κινητή συσκευή. Το περιεχόμενο ενός cookie μπορεί να ανακτηθεί ή να διαβαστεί μόνο από τον διακομιστή που δημιουργεί το cookie. Το κείμενο σε ένα cookie αποτελείται συχνά από αναγνωριστικά, ονόματα τοποθεσιών και ορισμένους αριθμούς και χαρακτήρες. Τα cookies είναι μοναδικά για τα προγράμματα περιήγησης ή τις κινητές εφαρμογές που χρησιμοποιείτε και επιτρέπουν στους ιστότοπους να αποθηκεύουν δεδομένα όπως οι προτιμήσεις σας.
                <br /><br />
                <strong>Υπεύθυνος Προστασίας Δεδομένων</strong><br /><br />

                Σε περίπτωση που έχετε ερωτήσεις σχετικά με την προστασία των δεδομένων σας και τα δικαιώματά σας, μπορείτε να στείλετε email dpo@pavlosmelas.gr ή να απευθυνθείτε εγγράφως στην ταχυδρομική διεύθυνση: Καραολή και Δημητρίου 1, Σταυρούπολη, 56430, ΘΕΣΣΑΛΟΝΙΚΗΣ και θα απαντήσουμε σε αυτές το συντομότερο δυνατόν και όχι αργότερα από έναν μήνα.
                <br /><br />

                <strong>Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα</strong><br /><br />

                Έχετε δικαίωμα να υποβάλλετε καταγγελία στην Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα (www.dpa.gr ), η οποία είναι η αρμόδια εποπτική αρχή για την προστασία των θεμελιωδών δικαιωμάτων και ελευθεριών των φυσικών προσώπων έναντι της επεξεργασίας των προσωπικών τους δεδομένων του, εφόσον θεωρείτε ότι προσβάλλονται τα δικαιώματά σας με οποιοδήποτε τρόπο.
                <br /><br />

                Σας παροτρύνουμε να δείτε την Πολιτική για την Ιδιωτικότητα και την Προστασία των Προσωπικών Δεδομένων του Ιδρύματος στον σύνδεσμο Πολιτική Ιδιωτικότητας και προστασίας δεδομένων.
                <br /><br />

            </Modal >
            <div className={classes.container}>
                <div className={classes.info} style={{ marginTop: 34, marginBottom: 43 }}>
                    <div className={classes.textBold}>
                        {t(`ΕΓΓΡΑΦΗ ΧΡΗΣΤΗ`)}
                    </div>
                    <Row justify="center">

                        <div className={classes.results} style={{ marginTop: 34, marginBottom: 43 }}>
                            <Form
                                form={form}
                                name="normal_register"
                                className="login-form"
                                initialValues={{ remember: false }}
                                onFinish={onFinish}
                            >
                                <div className={classes.title}>
                                    {t('Όνομα') + ' *'}
                                </div>
                                <Form.Item
                                    name="name"
                                    rules={[{ required: true, message: 'Υποχρεωτικό πεδίο!' }]}
                                >
                                    <Input className={classes.inputForm} placeholder="" />
                                </Form.Item>

                                <div className={classes.title}>
                                    {t('Επίθετο') + ' *'}
                                </div>
                                <Form.Item
                                    name="surname"
                                    rules={[{ required: true, message: 'Υποχρεωτικό πεδίο!' }]}
                                >
                                    <Input className={classes.inputForm} placeholder="" />
                                </Form.Item>

                                <div className={classes.title}>
                                    {t('Email') + ' *'}
                                </div>
                                <Form.Item
                                    name="email"
                                    rules={[
                                        { required: true, message: 'Υποχρεωτικό πεδίο!' },
                                        { type: 'email', message: 'Μη έγκυρη μορφή!' },
                                    ]}
                                    validateStatus={errorMessage ? 'error' : undefined}
                                    help={errorMessage}
                                >
                                    <Input className={classes.inputForm} placeholder="" />

                                </Form.Item>

                                <div className={classes.title}>
                                    {t('Φύλο') + ' *'}
                                </div>
                                <Form.Item
                                    name="gender"
                                    rules={[{ required: true, message: 'Υποχρεωτικό πεδίο!' }]}
                                >
                                    <Select
                                        className={classes.selectForm}
                                        defaultValue=""
                                        onChange={handleGender}
                                        options={[
                                            { value: 'Άρρεν', label: 'Άρρεν ' },
                                            { value: 'Θύλη', label: 'Θύλη' },
                                        ]}
                                    />
                                </Form.Item>

                                <div className={classes.title}>
                                    {t('Ημ. Γέννησης') + ' *'}
                                </div>
                                <Form.Item
                                    name="date_of_birth"
                                    rules={[{ required: true, message: 'Υποχρεωτικό πεδίο!' }]}
                                >
                                    <DatePicker onChange={onChange} locale={locale} className={classes.datePicker} placeholder="" />
                                </Form.Item>


                                <div className={classes.title}>
                                    {t('Τόπος Γέννησης') + ' *'}
                                </div>
                                <Form.Item
                                    name="place_of_birth"
                                    rules={[{ required: true, message: 'Υποχρεωτικό πεδίο!' }]}
                                >
                                    <Input className={classes.inputForm} placeholder="" />
                                </Form.Item>

                                <div className={classes.title}>
                                    {t('Τόπος Διαμονής') + ' *'}
                                </div>
                                <Form.Item
                                    name="residence"
                                    rules={[{ required: true, message: 'Υποχρεωτικό πεδίο!' }]}
                                >
                                    <Input className={classes.inputForm} placeholder="" />
                                </Form.Item>

                                <div className={classes.title}>
                                    {t('Σύλλογος') + ' *'}
                                </div>
                                <Form.Item
                                    name="club"
                                    rules={[{ required: true, message: 'Υποχρεωτικό πεδίο!' }]}
                                >
                                    <Input className={classes.inputForm} placeholder="" />
                                </Form.Item>

                                <div className={classes.title}>
                                    {t('ITRA') + ' *'}
                                </div>
                                <Form.Item
                                    name="itra"
                                    rules={[{ required: true, message: 'Υποχρεωτικό πεδίο!' }]}
                                >
                                    <Input className={classes.inputForm} placeholder=" " />
                                </Form.Item>

                                <div className={classes.title}>
                                    {t('Συνθηματικό') + ' *'}
                                </div>
                                <Form.Item
                                    name="pass"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Υποχρεωτικό πεδίο!',
                                        },
                                    ]}
                                    hasFeedback
                                >
                                    <Input.Password className={classes.inputForm} />
                                </Form.Item>

                                <div className={classes.title}>
                                    {t('Επιβεβαίωση συνθηματικού') + ' *'}
                                </div>
                                <Form.Item
                                    name="confirm_pass"
                                    dependencies={['pass']}
                                    hasFeedback
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Παρακαλούμε επιβεβαιώστε τον κωδικό πρόσβασής!',
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue('pass') === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('Οι δύο κωδικοί πρόσβασης δεν ταιριάζουν!'));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password className={classes.inputForm} />
                                </Form.Item>
                                <br />
                                <Form.Item
                                    name="agreement"
                                    valuePropName="checked"
                                    rules={[
                                        {
                                            validator: (_, value) =>
                                                value ? Promise.resolve() : Promise.reject(new Error('Υποχρεωτικό!')),
                                        },
                                    ]}
                                >
                                    <Checkbox className={classes.checkbox}>
                                        <u>Συμμετέχω στους εικονικούς αγώνες δρόμου με δική μου ελεύθερη βούληση και φέρω την πλήρη ευθύνη της συμμετοχής μου όσον αφορά τη φυσική μου κατάσταση και την ικανότητά μου να συμμετέχω. Οι διοργανωτές δεν φέρουν καμία ευθύνη σε περίπτωση τραυματισμού, ζημίας ή άλλου είδους φθοράς που μπορεί να υποστώ συμμετέχοντας στη διοργάνωση, κατά τη διάρκεια του αγώνα ή μετά το τέλος του.</u>
                                    </Checkbox>
                                </Form.Item>
                                <br /><br />
                                <Form.Item
                                    name="approves_result_sharing"
                                    valuePropName="checked"
                                    rules={[
                                        {
                                            validator: (_, value) =>
                                                value ? Promise.resolve() : Promise.reject(new Error('Υποχρεωτικό!')),
                                        },
                                    ]}
                                >
                                    <Checkbox className={classes.checkbox} onChange={onChangeSharing}>
                                        Συμφωνώ με τους όρους εγγραφής και επεξεργασίας προσωπικών δεδομένων  όπως αυτοί περιγράφονται στους <a href="/terms-of-use" target="_blank" rel="noopener noreferrer"><u>ΟΡΟΥΣ ΧΡΗΣΗΣ</u></a>
                                    </Checkbox>
                                </Form.Item>
                                <br /><br />

                                <span className={classes.requiredTerms}>* Υποχρεωτικά πεδία</span>

                                <br /><br />

                                <Form.Item>
                                    <div className={classes.login_container}>
                                        <Button type="primary" htmlType="submit" className={classes.upload_btn}>ΕΓΓΡΑΦΗ</Button>
                                    </div>
                                </Form.Item>
                            </Form>
                        </div>
                    </Row>

                </div>
            </div >
        </>
    )
}

export default Login;